module.exports = __webpack_public_path__ + "static/trailer_hw-4a720cd476ec3c5314b77cfa806fbd21.jpg";